import React, { useEffect, useState } from "react";

import Hamburger from "hamburger-react";

import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SelectLanguage from "../selectLanguage/SelectLanguage";

const TopBar = ({ navigation, whiteLogo, mainLogo }) => {
	const [isScrolled, setIsScrolled] = useState(false);
	const [isOpen, setOpen] = useState(false);
	const location = useLocation();
	const pathname = location?.pathname?.slice(1);
	const { t, i18n } = useTranslation();

	useEffect(() => {
		// Function to handle scroll event
		const handleScroll = () => {
			const scrolled = window.scrollY > 200;
			setIsScrolled(scrolled);
		};

		// Add scroll event listener when component mounts
		window.addEventListener("scroll", handleScroll);
	}, []);

	return (
		<header>
			<nav
				className={`${
					isScrolled || pathname !== ""
						? " fixed shadow-xl  bg-white"
						: "absolute"
				} flex items-center justify-between p-3 lg:px-14 inset-x-0 top-0 z-[99] transition`}
				aria-label='Global'>
				{/* logo */}
				<div className='flex lg:flex-1'>
					<Link to='/' className='-m-1.5 p-1.5'>
						<img
							className={"h-14 md:h-16  w-auto"}
							src={isScrolled || pathname !== "" ? mainLogo : whiteLogo}
							alt=''
						/>
					</Link>
				</div>

				{/* mobile menu icon */}
				<div className='flex lg:hidden'>
					<div className='flex justify-start items-center'>
						<Hamburger
							toggled={isOpen}
							toggle={setOpen}
							color={isScrolled || pathname !== "" ? "#faa726" : "#FFF"}
							className='h-6  w-6 -m-2.5 inline-flex items-center justify-center rounded-md p-2.5  '
							aria-hidden='true'
						/>
					</div>
				</div>

				{/* desktop nav links */}
				<div className='hidden lg:flex '>
					{navigation?.map((item, idx) => (
						<NavLink
							key={idx}
							to={item.to}
							className={`${
								isScrolled || pathname !== ""
									? "text-main_color"
									: "text-slate-100 "
							} text-lg px-4 py-2 text-center font-normal   hover:text-second_color  custom-transition`}>
							{i18n?.language === "ar" ? item.name_ar : item?.name_en}
						</NavLink>
					))}

					<a
						href='https://rajstore.sa'
						target='_blank'
						rel='noreferrer'
						className='text-lg  hover:bg-second_color hover:translate-x-1 hover:text-white  border-[1px] border-second_color rounded-md  font-normal flex items-center  px-3 py-2 gap-1 custom-transition group leading-6 text-second_color '>
						{t("our store in salla")}
						<span>
							{i18n?.language === "ar" ? <FiArrowLeft /> : <FiArrowRight />}
						</span>
					</a>
					<SelectLanguage pathname={pathname} />
				</div>
			</nav>

			{/* Mobile menu */}
			<div
				as='div'
				className={`${
					isOpen ? "open-menu" : "hidden"
				} lg:hidden fixed top-0 left-0 z-[999] flex-col p-5 h-screen   bg-section_bg w-full transition-[width]`}>
				<>
					<div className='flex items-center justify-between pb-10 '>
						{/* Close menu icon */}
						<Hamburger
							toggled={isOpen}
							toggle={setOpen}
							color='#faa726'
							className='h-6 w-6 -m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-brown_01'
							aria-hidden='true'
						/>

						<Link to='/' className='-m-1.5 p-1.5'>
							<img
								loading='lazy'
								className={"h-12 md:h-14  w-auto"}
								src={mainLogo}
								alt=''
							/>
						</Link>
					</div>
					{/* mobile menu links */}
					<div className=' flow-root text-center'>
						<div className=' flex justify-center items-center h-screen '>
							<div className='w-full -mt-28'>
								{navigation?.map((item, idx) => (
									<NavLink
										onClick={() => setOpen(!isOpen)}
										key={idx}
										to={item.to}
										className=' w-full mb-3 hover:bg-second_color hover:text-white  block page-links rounded-lg px-3 py-3 text-2xl font-medium leading-7 text-main_color '>
										{i18n?.language === "ar" ? item.name_ar : item?.name_en}
									</NavLink>
								))}

								<section className=' flex justify-center gap-3 mb-3'>
									<button
										onClick={() => {
											i18n.changeLanguage("ar");
											localStorage.setItem("language", "ar");
											window.location.reload();
										}}
										className='text-lg justify-center  text-white  rounded-md  font-normal flex items-center  px-3 py-2 gap-1  leading-6 bg-main_color '>
										{i18n?.language === "ar" ? "العربية" : "Arabic"}
									</button>
									<button
										onClick={() => {
											i18n.changeLanguage("en");
											localStorage.setItem("language", "en");
											window.location.reload();
										}}
										className='text-lg justify-center  text-white  rounded-md  font-normal flex items-center  px-3 py-2 gap-1  leading-6 bg-main_color '>
										{i18n?.language === "ar" ? "الانجليزية" : "English"}
									</button>
								</section>

								<a
									href='https://rajstore.sa'
									target='_blank'
									rel='noreferrer'
									className='text-lg justify-center hover:bg-second_color hover:translate-x-1 hover:text-white  border-[1px] border-second_color rounded-md  font-normal flex items-center  px-3 py-2 gap-1 custom-transition group leading-6 text-second_color '>
									{t("our store in salla")}
									<span>
										{i18n?.language === "ar" ? (
											<FiArrowLeft />
										) : (
											<FiArrowRight />
										)}
									</span>
								</a>
							</div>
						</div>
					</div>
				</>
			</div>
		</header>
	);
};

export default TopBar;
